import { Stack } from '@mui/material';

import { Typography, Button, FileUploadIcon, Divider } from '@occc/ui-design-system';

import { UploadedFileItem } from './uploaded-file-item.component';

import { DragAndDropAreaProps, HiddenFileInputProps, UploadedFileState } from '../segments.types';

type SegmentUploadFileProps = {
  shouldDisableControls: boolean;
  onBrowseFilesClick: () => void;
  dragAnDropAreaProps: DragAndDropAreaProps;
  hiddenFileInputProps: HiddenFileInputProps;
  uploadedFileState: UploadedFileState | null;
  isSmallProgressIndicator?: boolean;
};

export const SegmentUploadFile = ({
  shouldDisableControls,
  dragAnDropAreaProps,
  hiddenFileInputProps,
  onBrowseFilesClick,
  uploadedFileState,
  isSmallProgressIndicator,
}: SegmentUploadFileProps) => {
  return (
    <Stack>
      <Stack
        spacing={2}
        justifyContent='center'
        alignItems='center'
        py={5}
        px={2}
        borderRadius={2}
        border='1px dashed'
        sx={(theme) => ({
          backgroundColor: theme.palette.grey[100],
          borderColor: theme.palette.grey[400],
        })}
        {...dragAnDropAreaProps}
      >
        <FileUploadIcon color='action' />

        <Typography variant='body1'>Drag and Drop Files Here</Typography>

        <Typography variant='body1'>OR</Typography>

        <Button
          variant='contained'
          color='primary'
          disabled={shouldDisableControls}
          onClick={onBrowseFilesClick}
        >
          Browse Files
        </Button>

        {/* Hidden File Input, managed by react-dropzone */}
        <input {...hiddenFileInputProps} />
      </Stack>

      <Stack
        spacing={2}
        divider={<Divider />}
        justifyContent='center'
        mt={uploadedFileState ? 2 : undefined}
      >
        {uploadedFileState && (
          <UploadedFileItem
            name={uploadedFileState.fileName}
            progress={uploadedFileState.progress}
            isCompleted={false}
            isSmallProgressIndicator={isSmallProgressIndicator}
          />
        )}
      </Stack>
    </Stack>
  );
};
